import script from "./ShowMonitoraggioSpeditivo.vue?vue&type=script&setup=true&lang=js"
export * from "./ShowMonitoraggioSpeditivo.vue?vue&type=script&setup=true&lang=js"

import "./ShowMonitoraggioSpeditivo.vue?vue&type=style&index=0&id=ed8ef07e&lang=css"

const __exports__ = script;

export default __exports__